/**
 * Created by Wang.Qiong on 2021/9/11.
 */
import React from "react";
import { Modal } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const DEFAULT_IMAGE = require('../../assets/images/areatoraise-Five.jpg').default;

class flowImg extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
        }
    }

    handleCancel = () => {
        this.setState({
            visible: false,
        });
    };

    openModal = () => {
        this.setState({ visible: true });
    };

    render() {
        const { visible } = this.state
        const {
            label = '登记、选房规则',
            imageSrc = DEFAULT_IMAGE,
            showIcon = true,
            clickableText = false,
        } = this.props

        return (
            <div style={{ display: 'inline' }}>
                <span style={{ display: showIcon ? 'flex' : 'inline', alignItems: 'center' }}>
                    {showIcon ? (
                        <QuestionCircleOutlined onClick={this.openModal} style={{ fontSize: '18px', color: 'red' }} />
                    ) : null}
                    <span
                        style={{
                            marginLeft: showIcon ? '10px' : 0,
                            ...(clickableText ? { color: '#1890ff', cursor: 'pointer' } : {}),
                        }}
                        onClick={clickableText ? this.openModal : undefined}
                    >
                        {label}
                    </span>
                </span>
                {visible ? (
                    <Modal
                        centered
                        visible={visible}
                        onOk={this.handleCancel}
                        onCancel={this.handleCancel}
                        width={1000}
                        footer={[]}
                    >
                        <img style={{ width: '100%' }} src={imageSrc} alt="" />
                    </Modal>
                ) : null}
            </div>
        )
    }

}
export default flowImg;
